/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import { baseChallengeBodyObjectSchema, titleQualityRefine } from '../challenge-body-schema';

export const updateChallengeBodySchema = baseChallengeBodyObjectSchema
  .partial()
  .superRefine(titleQualityRefine);

export type IUpdateChallengeBody = z.infer<typeof updateChallengeBodySchema>;

export interface IUpdateChallengeRequest {
  id: number;
  body: IUpdateChallengeBody;
}
